module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.loading) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('form.wooCredentialsModal.title')) + " "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('div', [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v(_vm._s(_vm.$t('form.wooCredentialsModal.title')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "form": _vm.form,
      "translation": "form.wooCredentialsModal",
      "hasLabel": true
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "margin-b-10"
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.wooCredentialsModal.kundanWordpressPluginToken')))]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('el-input', {
    ref: "tokenInput",
    staticClass: "input-with-icon margin-b-10",
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.token),
      callback: function($$v) {
        _vm.token = $$v
      },
      expression: "token"
    }
  }, [_c('el-button', {
    staticStyle: {
      "padding": "12px 20px",
      "margin-right": "-7px"
    },
    attrs: {
      "slot": "append",
      "loading": _vm.generateTokenLoading
    },
    on: {
      "click": _vm.generateToken
    },
    slot: "append"
  }, [_vm._v("Generate")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "padding": "12px 20px"
    },
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.copyToken
    },
    slot: "append"
  }, [_vm._v("Copy")])], 1)], 1)])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.cancel').toUpperCase()) + "\n      ")]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.store
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.save').toUpperCase()) + "\n      ")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-308b5246","hasScoped":false}!./src/app/components/wooCredentialsModal/wooCredentialsModal.html
// module id = 2958
// module chunks = 1